// 政策快讯
import request from '@/utils/request'

// 查询全部的政策快讯数据
export const getPolicyList = params => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_APPSERVER + '/api/iPolicyFlash/pageTab',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		params
	})
}
